/**
 * The audit trail. Read-only — every row is written by the `SaveChangesAsync` interceptor on the
 * server, never by a call from here. `search` and `entityHistory` answer different questions:
 * one is "what happened, filtered", the other is "everything that ever happened to this one thing".
 */

import { api } from '../api.js';
import type { AuditLog, Paged, ShopId, UserId } from '../../types/api.js';

export type SearchAuditParams = {
  readonly userId?: UserId | undefined;
  readonly shopId?: ShopId | undefined;
  readonly entityId?: string | undefined;
  readonly entityType?: string | undefined;
  readonly action?: string | undefined;
  readonly from?: string | undefined;
  readonly to?: string | undefined;
  readonly page?: number | undefined;
  readonly pageSize?: number | undefined;
};

export const auditApi = api.injectEndpoints({
  endpoints: (build) => ({
    searchAudit: build.query<Paged<AuditLog>, SearchAuditParams>({
      query: (params) => ({ url: '/audit', params: { page: 1, pageSize: 50, ...params } }),
    }),

    getEntityAuditHistory: build.query<AuditLog[], string>({
      query: (entityId) => `/audit/entity/${entityId}`,
    }),

    listAuditActions: build.query<string[], void>({
      query: () => '/audit/actions',
    }),
  }),
});

export const { useSearchAuditQuery, useGetEntityAuditHistoryQuery, useListAuditActionsQuery } = auditApi;
